<template>
  <div>
    <page-description>
      <template v-slot:heading>Profile</template>
      <template v-slot:subheading>View, edit, and manage profile settings</template>
    </page-description>

    <div class="dropdown d-block d-xl-none text-center my-4 submit mx-3 mx-sm-4 mx-md-5">
      <button
          @click="setDropdownList"
          class="text-left border-0 w-100 dropdown-toggle text-capitalize font-weight-bold"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
      >
        {{ tabActive }}
        <span class="float-right">
          <i class="font-weight-bold fa" :class="{ 'fa-angle-down': angleDown, 'fa-angle-up': !angleDown }"
             aria-hidden="true"></i>
        </span>
      </button>
      <div class="dropdown-menu py-0 w-100" style="box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);"
           aria-labelledby="dropdownMenuButton">
        <span @click="changeTab(item);  callAPI();"
              class="text-capitalize dropdown-item link-text pl-3 border-bottom w-100 py-2"
              v-for="item in dropdownList"
        >
          {{ item }}
        </span>
      </div>
    </div>

    <div class="col-xl-9 col-sm-12 mr-3 ml-3 mr-sm-5 ml-sm-5 mt-sm-3 d-none d-xl-block pl-sm-0">
      <nav class="nav nav-pills submit">
        <button
            type="submit"
            class="px-sm-5 mx-sm-1 rounded border-0 nav-item nav-link text-capitalize"
            :class="{ active: tabActive === tab }"
            @click="changeTab(tab);  callAPI();"
            v-for="tab in tabs"
        >
          {{ tab }}
        </button>
      </nav>
    </div>

    <div v-if="tabActive === 'user information'"
         class="mt-sm-4 mb-5 mx-2 ml-sm-3 mr-sm-0 pl-0 pl-sm-2">
      <user-information
          :user-data="userData"
          @changeTab="changeOnCompClick"
      ></user-information>
    </div>
    <div v-else-if="tabActive === 'tax information'"
         class="mt-sm-4 mb-sm-5 mx-2 ml-sm-3 mr-sm-0 pl-0 pl-sm-2">
      <tax-information
          :user-data="userData">
      </tax-information>
    </div>
    <div v-else-if="tabActive === 'login method'"
         class="mt-sm-4 mx-2 ml-sm-3 mr-sm-0 pl-0 pl-sm-2">
      <login-method
          :user-data="userData"
          @changeTab="changeOnCompClick"
          @updateFetchAPI="updateFetchAPIData"
      ></login-method>
    </div>
    <div v-else class="mt-sm-4 mx-2 ml-sm-3 mr-sm-0 pl-0 pl-sm-2">
      <the-account
          :user-data="userData"
          @changeTab="changeOnCompClick"
      ></the-account>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    "the-card": () => import(/*webpackChunkName: "TheCard"*/ '../widgets/TheCard'),
    "user-information": () => import(/*webpackChunkName: "UserInformation"*/ '../profile/UserInformation'),
    "tax-information": () => import(/*webpackChunkName: "TaxInformation"*/ '../profile/TaxInformation'),
    "login-method": () => import(/*webpackChunkName: "LoginMethod"*/ '../profile/LoginMethod'),
    "the-account": () => import(/*webpackChunkName: "TheAccount"*/ '../profile/TheAccount'),
    "page-description": () => import(/*webpackChunkName: "PageDescription"*/ '../widgets/PageDescription')
  },
  created() {

    /** FetchAPI method is written in main.js, Its use is to get details of user from database */
    this.fetchAPI();

    this.$emit("routeName", this.$route.name);

    /** Set title for the TheProfile module */
    const titleEl = document.querySelector('head title');
    titleEl.textContent = 'QR Batch | Profile';

  },
  data() {
    return {
      tabActive: "user information",
      tabs: ["user information", "tax information", "login method", "account"],
      dropdownList: [],
      angleDown: true,
      userData: "",
      notifyExpiry: ''
    };
  },
  methods: {
    changeOnCompClick(value) {
      this.changeTab(value);
    },

    /** Method used to change tabs in Profile module */
    changeTab(value) {
      this.tabActive = value;
      this.angleDown = true;
    },

    /** Method used to show dropdown list instead of tabs in mobile view */
    setDropdownList() {
      this.angleDown =
          $("#dropdownMenuButton").attr("aria-expanded") !== "false";
      this.dropdownList = [];
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i] !== this.tabActive) {
          this.dropdownList.push(this.tabs[i]);
        }
      }
    },
    callAPI() {
      this.fetchAPI();
    },
    updateFetchAPIData() {
      this.callAPI();
    }
  }
};
</script>

<style scoped>
.submit button {
  padding: 5.5px 20px;
}

/deep/ .form-control {
  background-color: rgba(235, 227, 227, 0.1);
  border: 1px solid #e5e5e5;
}

/deep/ ::placeholder {
  opacity: 0.7;
  color: #b9b9b9;
}

</style>
